// extracted by mini-css-extract-plugin
export default {"icon-button":"Organizations_icon-button__MQatP","card-body":"Organizations_card-body__fVZC7","fa-lg":"Organizations_fa-lg__Dj8tC","actionBtns":"Organizations_actionBtns__giVRh"};